export const LOAD_CHALLENGES_WORKOUTGROUPS = 'LOAD_CHALLENGES_WORKOUTGROUPS';
export const LOAD_ROUTINES_WORKOUTGROUPS = 'LOAD_ROUTINES_WORKOUTGROUPS';
export const LOAD_YOGA_GROUPS = 'LOAD_YOGA_GROUPS';